import { render, staticRenderFns } from "./GoalsDisplay.vue?vue&type=template&id=3c6951ae&"
import script from "./GoalsDisplay.vue?vue&type=script&lang=js&"
export * from "./GoalsDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports